import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/state';
import { selectSidenavOpened } from '../../store/selectors';
import * as CoreActions from '../../store/actions';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  readonly sidenavOpened$ = this.store.select(selectSidenavOpened);

  constructor(private store: Store<IAppState>) {}

  toggleSidenav(): void {
    this.store.dispatch(CoreActions.toggleSidenav());
  }

  setSidenavOpened(opened: boolean): void {
    this.store.dispatch(CoreActions.setSidenavOpened({ opened }));
  }
}
